import { snakeCase } from 'lodash-es';
import { AUTOPLAY_MARGIN_TOP } from '../constants';

// plus 10 entries and then round up to nearest 10
export const roundUpNearest10 = (num) => {
  const n = num < 1 ? 10 : num + 10;
  return Math.ceil(n / 10) * 10;
};

/**
 * @description Helper function that returns analytic properties for tracking
 * number of entries for the first page of entries on initial load.
 *
 * The preFetchedEntries data is injected on the server side. As a result,
 * Web will only have context for the first page of entries (max of 20 entries)
 * on the initial load.
 *
 * We are only concerned about tracking the first page of entries on the initial load.
 *
 * @params {Array.<unknown>} preFetchedEntries - the feed entries
 *
 * @returns {Object.<{ inventorySize: number, trackedPageCount: number, inventoryPageSizes: number[], inventoryEntryTypes:  string[] }>} - the tracking data properties
 * */
export const getFeedAnalyticsFinishLoadData = (preFetchedEntries) => {
  /**
   * defaultNumEntries => max number of entries for the fist page load on initial load.
   * */
  const defaultNumEntries = 20;

  const firstPage = preFetchedEntries.slice(0, defaultNumEntries);

  // Size of the first page of entries
  const inventorySize = firstPage.length || 0;
  // Number of pages that were used to track the inventory size
  // We are only concerned about tracking the first page entries on the initial load.
  const trackedPageCount = 1;
  // Sizes for each of the loaded pages
  const inventoryPageSizes = [inventorySize];
  // Use page to identify the entry type
  const inventoryEntryTypes = firstPage.map((entry) => snakeCase(entry.entity));

  return {
    inventorySize,
    trackedPageCount,
    inventoryPageSizes,
    inventoryEntryTypes
  };
};

export const createPath = ({ search: searchProp }) => {
  const { location } = window;
  const { pathname, hash } = location;
  const search = typeof searchProp === 'string' ? searchProp : location.search;
  let path = pathname || '/';

  if (search && search !== '?') {
    path += search.charAt(0) === '?' ? `${search}&` : `?${search}`;
  }

  if (hash && hash !== '#') {
    path += hash.charAt(0) === '#' ? hash : `#${hash}`;
  }

  return path;
};

// AutoPlay Video
export const rootMargin = (padding = 0) => {
  const pageHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const rootMarginDiff = pageHeight - (AUTOPLAY_MARGIN_TOP + padding);
  return rootMarginDiff > 0
    ? `-${AUTOPLAY_MARGIN_TOP}px 0px -${rootMarginDiff}px 0px`
    : `0px`;
};
